import { createCreateListFormData, createUpdateItemFormData, createUpdateListFormData, listActionStandard } from './helper';
import { messageBoxSuccess, messageBoxError } from '../components/message-box';
import FormValidation from '../components/form-validation';

class Share {
  public popup: HTMLElement;

  public shareButtons: NodeListOf<HTMLElement>;

  public selectionButtons: NodeListOf<HTMLElement>;

  public shareLink: string;

  public wishlistContent: any;

  public wishlistShared: any;

  public selectedProducts: Array<any> = [];

  private formValidation: FormValidation;

  public preselected: string | undefined;

  public savedPreselected: string | undefined;

  constructor(wishlistContent: any, wishlistShared: any) {
    this.wishlistContent = wishlistContent;
    this.wishlistShared = wishlistShared;
  }

  updateItem(itemId: string, listId: string, action: string, jsonSharedIn: any) {
    try {
      const updateItemFormData = createUpdateItemFormData(itemId, listId);

      if (action === 'remove') {
        const newJson = JSON.stringify([...JSON.parse(jsonSharedIn).filter((listId: number) => listId !== this.wishlistShared.id)]);

        // @ts-ignore
        this.popup.querySelector(`.o-wishlist-accordion__selection[data-wishlist-id="${itemId}"]`).dataset.jsonSharedIn = newJson;
        updateItemFormData.append('fields[json_shared_in]', newJson);
      } else {
        const newJson = JSON.stringify([...JSON.parse(jsonSharedIn), this.wishlistShared.id]);

        // @ts-ignore
        this.popup.querySelector(`.o-wishlist-accordion__selection[data-wishlist-id="${itemId}"]`).dataset.jsonSharedIn = newJson;
        updateItemFormData.append('fields[json_shared_in]', newJson);
      }

      listActionStandard(updateItemFormData);

      const updateListFormData = createUpdateListFormData(this.wishlistShared.id);

      updateListFormData.append(
        'fields[plaintext_title_2]',
        `${new Date().toLocaleDateString('en-US')},
        ${new Date().toLocaleTimeString('de-DE', { hour12: false, hour: '2-digit', minute: '2-digit' })}`,
      );

      listActionStandard(updateListFormData);
    } catch (e) {
      console.error(e);

      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Konnte nicht gespeichert werden.',
        contentEn: 'An error appeared. Could not save.',
      });
    }
  }

  handleSelection(e: Event | null, preselectedButton: null | HTMLElement = null) {
    const target = preselectedButton ? preselectedButton : e?.currentTarget as HTMLElement;

    switch (target.dataset.type) {
      case 'list':
        if (
          target.classList.contains('is-selected') &&
          target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection.is-selected').length ==
            target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection').length
        ) {
          const productsToRemove = target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection[data-type="product"]');
          productsToRemove?.forEach((element: any) => {
            this.updateItem(element.dataset.wishlistId, element.dataset.sectionId, 'remove', element.dataset.jsonSharedIn);
            this.selectedProducts = this.selectedProducts.filter((product: any) => product.wishlist_id != element.dataset.wishlistId);
          });

          target.classList.remove('is-selected');
          target
            .closest('.o-wishlist-accordion__list')
            ?.querySelectorAll('.o-wishlist-accordion__selection')
            ?.forEach((element) => element.classList.remove('is-selected'));
        } else {
          const productsToAdd = target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection:not(.is-selected)[data-type="product"]');
          productsToAdd?.forEach((element: any) => {
            this.updateItem(element.dataset.wishlistId, element.dataset.sectionId, 'add', element.dataset.jsonSharedIn);
            this.selectedProducts.push({
              name: element.dataset.name,
              url: element.dataset.url,
              image_url: element.dataset.imageUrl,
              description: element.dataset.description,
              web_teaser: element.dataset.webTeaser,
              element_quantity: element.dataset.elementQuantity,
              element_type: element.dataset.elementType,
              element_id: element.dataset.elementId,
              wishlist_id: element.dataset.wishlistId,
            });
          });

          target.classList.add('is-selected');
          target
            .closest('.o-wishlist-accordion__list')
            ?.querySelectorAll('.o-wishlist-accordion__selection')
            ?.forEach((element) => element.classList.add('is-selected'));
        }
        break;
      case 'section':
        if (
          target.classList.contains('is-selected') &&
          target.closest('.o-wishlist-accordion__group')?.querySelectorAll('.o-wishlist-accordion__selection.is-selected').length ==
            target.closest('.o-wishlist-accordion__group')?.querySelectorAll('.o-wishlist-accordion__selection').length
        ) {
          const productsToRemove = target.closest('.o-wishlist-accordion__group')?.querySelectorAll('.o-wishlist-accordion__selection[data-type="product"]');
          productsToRemove?.forEach((element: any) => {
            this.updateItem(element.dataset.wishlistId, element.dataset.sectionId, 'remove', element.dataset.jsonSharedIn);
            this.selectedProducts = this.selectedProducts.filter((product: any) => product.wishlist_id != element.dataset.wishlistId);
          });

          target.classList.remove('is-selected');
          target
            .closest('.o-wishlist-accordion__group')
            ?.querySelectorAll('.o-wishlist-accordion__selection')
            ?.forEach((element) => element.classList.remove('is-selected'));
          if (target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection.is-selected').length == 1) {
            target.closest('.o-wishlist-accordion__list')?.querySelector('.o-wishlist-accordion__selection')?.classList.remove('is-selected');
          }
        } else {
          const productsToAdd = target.closest('.o-wishlist-accordion__group')?.querySelectorAll('.o-wishlist-accordion__selection:not(.is-selected)[data-type="product"]');
          productsToAdd?.forEach((element: any) => {
            this.updateItem(element.dataset.wishlistId, element.dataset.sectionId, 'add', element.dataset.jsonSharedIn);
            this.selectedProducts.push({
              name: element.dataset.name,
              url: element.dataset.url,
              image_url: element.dataset.imageUrl,
              description: element.dataset.description,
              web_teaser: element.dataset.webTeaser,
              element_quantity: element.dataset.elementQuantity,
              element_type: element.dataset.elementType,
              element_id: element.dataset.elementId,
              wishlist_id: element.dataset.wishlistId,
            });
          });

          target.classList.add('is-selected');
          target
            .closest('.o-wishlist-accordion__group')
            ?.querySelectorAll('.o-wishlist-accordion__selection')
            ?.forEach((element) => element.classList.add('is-selected'));
          target.closest('.o-wishlist-accordion__list')?.querySelector('.o-wishlist-accordion__selection')?.classList.add('is-selected');
        }
        break;
      case 'product':
        if (target.classList.contains('is-selected')) {
          this.updateItem(target.dataset.wishlistId || '', target.dataset.sectionId || '', 'remove', target.dataset.jsonSharedIn);
          this.selectedProducts = this.selectedProducts.filter((product: any) => product.wishlist_id != target.dataset.wishlistId);

          target.classList.remove('is-selected');
          if (target.closest('.o-wishlist-accordion__group')?.querySelectorAll('.o-wishlist-accordion__selection.is-selected').length == 1) {
            target.closest('.o-wishlist-accordion__group')?.querySelector('.o-wishlist-accordion__selection')?.classList.remove('is-selected');
          }
          if (target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection.is-selected').length == 1) {
            target.closest('.o-wishlist-accordion__list')?.querySelector('.o-wishlist-accordion__selection')?.classList.remove('is-selected');
          }
        } else {
          this.updateItem(target.dataset.wishlistId || '', target.dataset.sectionId || '', 'add', target.dataset.jsonSharedIn);
          this.selectedProducts.push({
            name: target.dataset.name,
            url: target.dataset.url,
            image_url: target.dataset.imageUrl,
            description: target.dataset.description,
            web_teaser: target.dataset.webTeaser,
            element_type: target.dataset.elementType,
            element_quantity: target.dataset.elementQuantity,
            element_id: target.dataset.elementId,
            wishlist_id: target.dataset.wishlistId,
          });

          target.classList.add('is-selected');
          target.closest('.o-wishlist-accordion__group')?.querySelector('.o-wishlist-accordion__selection')?.classList.add('is-selected');
          target.closest('.o-wishlist-accordion__list')?.querySelector('.o-wishlist-accordion__selection')?.classList.add('is-selected');
        }
        break;
      default:
    }
  }

  async copyLink(e: Event | null) {
    e?.preventDefault();

    try {
      await navigator.clipboard.writeText(this.shareLink);
      messageBoxSuccess({
        contentDe: 'Link wurde kopiert.',
        contentEn: 'Copied link.',
      });
    } catch (e) {
      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Link konnte nicht kopiert werden.',
        contentEn: 'An error appeared. Could not copy link.',
      });
    }
  }

  initFormActions(action: string | undefined) {
    // console.log('TODO: add unbindings');
    if (action === 'link' || action === 'whatsapp') {
      const linkInput = this.popup.querySelector('.m-wishlist-popup-share__link-form input') as HTMLInputElement | null;
      const linkButton = this.popup.querySelector('.m-wishlist-popup-share__link-form button') as HTMLInputElement | null;

      if (linkInput) {
        linkInput.value = this.shareLink;
      }

      linkButton?.addEventListener('click', async (e: Event) => {
        e.preventDefault();

        this.copyLink(e);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ action: null });
        window.dataLayer.push({
          event: 'share',
          content_type: 'wishlist',
          content_id: this.shareLink,
          method: 'link',
          action: {
            content_type: 'wishlist'
          }
        });
      });
    }

    if (action === 'link') {
      const submitButton = this.popup.querySelector('.m-wishlist-popup-share__button-submit') as HTMLElement | null;

      submitButton?.addEventListener('click', async (e: Event) => {
        e.preventDefault();

        await this.copyLink(e);

        const link = document.createElement('a');

        link.target = '_blank';
        link.href = this.shareLink;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ action: null });
        window.dataLayer.push({
          event: 'share',
          content_type: 'wishlist',
          content_id: this.shareLink,
          method: 'link',
          action: {
            content_type: 'wishlist'
          }
        });
      });
    } else if (action === 'whatsapp') {
      const submitButton = this.popup.querySelector('.m-wishlist-popup-share__button-submit') as HTMLElement | null;

      submitButton?.addEventListener('click', async (e: Event) => {
        e.preventDefault();

        await this.copyLink(e);

        const link = document.createElement('a');

        link.target = '_blank';
        // works desktop and mobile
        link.href = `https://api.whatsapp.com/send?text=${this.shareLink}`;
        // only works mobile, but is faster
        // link.href = `whatsapp://send?text=${this.shareLink}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ action: null });
        window.dataLayer.push({
          event: 'share',
          content_type: 'wishlist',
          content_id: this.shareLink,
          method: 'whatsapp',
          action: {
            content_type: 'wishlist'
          }
        });
      });
    } else {
      const form = this.popup.querySelector('.m-wishlist-popup-share__mail-form form') as HTMLFormElement | null;

      if (form) {
        this.formValidation = new FormValidation(
          form,
          () => {
            if (form?.reportValidity()) {
              form.classList.add('loading');

              const endpoint = form?.action || '';
              const data = new FormData();

              data.append('name_from', (document.getElementById('m-wishlist-popup-share__mail-name') as HTMLInputElement || null)?.value || '');
              data.append('mail_from', (document.getElementById('m-wishlist-popup-share__mail-user-mail') as HTMLInputElement || null)?.value || '');
              data.append('mail_to', (document.getElementById('m-wishlist-popup-share__mail-mail') as HTMLInputElement || null)?.value || '');
              data.append('name_recipient', (document.getElementById('m-wishlist-popup-share__mail-recipient') as HTMLInputElement || null)?.value || '');
              data.append('message', (document.getElementById('m-wishlist-popup-share__mail-message') as HTMLInputElement || null)?.value || '');
              data.append('shared_link', this.shareLink);

              this.selectedProducts.forEach((product: any, index) => {
                data.append(`product[]`, JSON.stringify(product));
              });

              fetch(endpoint, {
                method: 'post',
                body: data,
              })
                .then((res) => res.json())
                .then(res => {
                  if (res.success == true || res.success === 'true') {
                    messageBoxSuccess({
                      contentDe: 'E-Mail wurde erfolgreich gesendet.',
                      contentEn: 'Successfully sent e-mail.',
                    });

                    this.popup?.classList.add('success');

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ action: null });
                    window.dataLayer.push({
                      event: 'share',
                      content_type: 'wishlist',
                      content_id: this.shareLink,
                      method: 'email',
                      action: {
                        content_type: 'wishlist'
                      }
                    });
                  }
                })
                .catch((error) => {
                  console.error(error);

                  messageBoxError({
                    contentDe: 'Es ist ein Fehler aufgetreten. E-Mail konnte nicht gesendet werden.',
                    contentEn: 'An error appeared. Could not send e-mail.',
                  });
                });
            }
          },
          () => this.srollToError(form)
        );
        this.formValidation.init();
      }

    }
  }

  private srollToError(elForm: HTMLElement) {
    const elError = elForm.querySelector('.has-error');
    if (elError) {
      const top = elError.getBoundingClientRect().top + this.popup.scrollTop - 50;
      this.popup.scrollTo({top});
      (elError as HTMLElement).focus();
    }
  }

  prefill() {
    this.wishlistContent.forEach((list: any) => {
      list.items.forEach((item: any) => {
        if (item.json_shared_in) {
          this.popup.querySelector(`.o-wishlist-accordion__selection[data-wishlist-id="${item.wishlist_id}"]`)?.classList.add('is-selected');
        }
      });

      list.sections.forEach((section: any) => {
        section.items.forEach((item: any) => {
          if (item.json_shared_in) {
            this.popup.querySelector(`.o-wishlist-accordion__selection[data-wishlist-id="${item.wishlist_id}"]`)?.classList.add('is-selected');
          }
        });
      });
    });

    this.popup.querySelectorAll('.o-wishlist-accordion__group').forEach((section) => {
      if (section.querySelectorAll('.o-wishlist-accordion__selection-product.is-selected').length == section.querySelectorAll('.o-wishlist-accordion__selection-product').length) {
        section.querySelector('.o-wishlist-accordion__selection-section')?.classList.add('is-selected');
      }
    });

    this.popup.querySelectorAll('.o-wishlist-accordion__list').forEach((list) => {
      if (list.querySelectorAll('.o-wishlist-accordion__selection-section.is-selected').length == list.querySelectorAll('.o-wishlist-accordion__selection-section').length) {
        list.querySelector('.o-wishlist-accordion__selection-list')?.classList.add('is-selected');
      }
    });
  }

  selectAll() {
    const buttons = this.popup.querySelectorAll('.o-wishlist-accordion__selection[data-type="product"]');

    buttons?.forEach((element: any) => {
      this.updateItem(element.dataset.wishlistId, element.dataset.sectionId, 'add', element.dataset.jsonSharedIn);

      try {
        this.updateItem(element.dataset.wishlistId, element.dataset.sectionId, 'add', element.dataset.jsonSharedIn);

        this.selectedProducts.push({
          name: element.dataset.name,
          url: element.dataset.url,
          image_url: element.dataset.imageUrl,
          description: element.dataset.description,
          web_teaser: element.dataset.webTeaser,
          element_quantity: element.dataset.elementQuantity,
          element_type: element.dataset.elementType,
          element_id: element.dataset.elementId,
          wishlist_id: element.dataset.wishlistId,
        });

        element.classList.add('is-selected');
      } catch (e) {
        console.error(e);
        element.classList.remove('is-selected');

        messageBoxError({
          contentDe: 'Es ist ein Fehler aufgetreten. Konnte nicht ausgewählt.',
          contentEn: 'An error appeared. Could not select.',
        });
      }
    });
  }

  async bindings() {
    this.handleSelection = this.handleSelection.bind(this);
    this.copyLink = this.copyLink.bind(this);
    const apiBaseUrl = document.body.dataset.apiBaseUrl;

    if (this.shareButtons) {
      this.shareButtons.forEach((button) => {
        button.addEventListener('pointerup', async () => {
          this.preselected = button.dataset.preselected;

          if (button.dataset.target === '') {
            this.popup = document.querySelector('.m-wishlist-popup-share#wishlist-popup-share-link') as HTMLElement;

            const newListFormData = createCreateListFormData(`${Math.floor(Math.random() * 100000)}`, 'wishlist_shared');

            newListFormData.append('fields[plaintext_title_1]', new Date().toLocaleDateString('en-US'));

            this.wishlistShared = await listActionStandard(newListFormData);

            this.shareLink = `${apiBaseUrl}shared?id=${this.wishlistShared.reference}`;

            this.copyLink(null);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ action: null });
            window.dataLayer.push({
              event: 'share',
              content_type: 'wishlist',
              content_id: this.shareLink,
              method: 'link',
              action: {
                content_type: 'wishlist'
              }
            });

            this.selectionButtons = this.popup.querySelectorAll('.o-wishlist-accordion__selection');

            this.selectionButtons.forEach((button) => {
              if (this.preselected && this.preselected != this.savedPreselected) {
                button.classList.remove('is-selected');
              } else {
                button.classList.add('is-selected');
              }
            });

            if (this.preselected) {
              const preselectedButton = Array.from(this.selectionButtons).filter((button) => button.dataset.listId == this.preselected)[0];

              if (preselectedButton) {
                this.handleSelection(null, preselectedButton);
              }
            } else {
              this.selectAll();
            }

            this.savedPreselected = this.preselected;
          } else {
            if (button.dataset.action === 'mail') {
              this.popup = document.querySelector('.m-wishlist-popup-share#wishlist-popup-share-email') as HTMLElement;
            } else {
              this.popup = document.querySelector('.m-wishlist-popup-share#wishlist-popup-share-whatsapp') as HTMLElement;
            }
            const newListFormData = createCreateListFormData(`${Math.floor(Math.random() * 100000)}`, 'wishlist_shared');

            newListFormData.append('fields[plaintext_title_1]', new Date().toLocaleDateString('en-US'));

            this.wishlistShared = await listActionStandard(newListFormData);

            this.shareLink = `${apiBaseUrl}shared?id=${this.wishlistShared.reference}`;

            this.initFormActions(button.dataset.action);

            this.selectionButtons = this.popup.querySelectorAll('.o-wishlist-accordion__selection');

            this.selectionButtons.forEach((button) => {
              if (this.preselected && this.preselected != this.savedPreselected) {
                button.classList.remove('is-selected');
              } else {
                button.classList.add('is-selected');
              }

              button.addEventListener('click', this.handleSelection);
            });

            if (this.preselected) {
              const preselectedButton = Array.from(this.selectionButtons).filter((button) => button.dataset.listId == this.preselected)[0];

              if (preselectedButton) {
                this.handleSelection(null, preselectedButton);
              }
            } else {
              this.selectAll();
            }

            this.savedPreselected = this.preselected;
          }

        });
      });
    }
  }

  cache() {
    this.shareButtons = document.querySelectorAll('.a-wishlist-link');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Share;
